import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
// Simple counter hook for the stats
function useCounter(end: number, duration: number = 2000, inView: boolean) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let startTime: number | null = null;
    let animationFrame: number;
    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      // easeOutQuart
      const easeProgress = 1 - Math.pow(1 - progress, 4);
      setCount(Math.floor(easeProgress * end));
      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration, inView]);
  return count;
}
export function StatsSection() {
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.2
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const stats = [{
    value: 4,
    suffix: '+',
    label: 'Service Areas'
  }, {
    value: 1000,
    suffix: '+',
    label: 'Happy Customers'
  }, {
    value: 100,
    suffix: '%',
    label: 'Free Delivery'
  }, {
    value: 24,
    suffix: '/7',
    label: 'Customer Support'
  }];
  return <section ref={sectionRef} className="py-20 bg-brand-navy relative overflow-hidden" data-id="element-458">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-459"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-460">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 text-center" data-id="element-461">
          {stats.map((stat, index) => {
          const count = useCounter(stat.value, 2000, isInView);
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            delay: index * 0.1,
            duration: 0.6
          }} className="flex flex-col items-center" data-id="element-462">
                <div className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-2 flex items-center justify-center" data-id="element-463">
                  {count}
                  <span className="text-brand-red ml-1" data-id="element-464">{stat.suffix}</span>
                </div>
                <div className="text-white/80 font-medium text-sm md:text-base uppercase tracking-wider" data-id="element-465">
                  {stat.label}
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}